import React, { useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteStudentCohortEnrollment({
  open,
  onOpenChange,
  cohortId,
  cohortName,
  userId,
  courseId,
  studentName,
  onDeleted,
  refetchEnrolments,
}) {
  const [loading, setLoading] = useState(false);
  const { getToken } = useAuth();

  const handleDelete = async () => {
    if (cohortId == null || userId == null || courseId == null) {
      console.warn("Missing ids for cohort enrolment delete", {
        cohortId,
        userId,
        courseId,
      });
      toast.error(
        `Missing enrolment ids (cohortId: ${String(cohortId)}, userId: ${String(
          userId
        )}, courseId: ${String(courseId)})`
      );
      return;
    }

    setLoading(true);
    try {
      const token = await getToken();
      if (!token) return;

      const reqConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      await axios.delete(
        api_endpoint + `/cohort/enrollment/${cohortId}/${userId}/${courseId}`,
        reqConfig
      );

      toast.success(
        `Cohort enrolment for "${studentName || "student"}" deleted successfully!`
      );
      onOpenChange(false);
      onDeleted?.();
      // Defer so parent refetch isn't affected by dialog state batching.
      if (refetchEnrolments) setTimeout(() => refetchEnrolments(), 0);
    } catch (error) {
      console.error("Error deleting cohort enrolment:", error);
      toast.error(
        `Failed to delete cohort enrolment for "${studentName || "student"}".`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-(--surface-panel) text-(--neutral-900)">
        <DialogHeader>
          <DialogTitle className="font-heading text-(--neutral-900)">
            Delete Cohort Enrolment
          </DialogTitle>
        </DialogHeader>
        <div className="font-body text-(--neutral-800)">
          Are you sure you want to delete <b>{studentName}</b>
          {cohortName ? (
            <>
              {" "}
              from <b>{cohortName}</b>
            </>
          ) : (
            " from this cohort"
          )}
          {" "}
          enrolment? This action cannot be undone.
        </div>

        <div className="mt-4 flex gap-2 justify-between">
          <DialogClose asChild>
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={loading}
            >
              Cancel
            </Button>
          </DialogClose>
          <Button variant="" onClick={handleDelete} disabled={loading}>
            {loading ? (
              <span className="flex items-center justify-center w-full">
                <ClipLoader size={20} color="#fff" />
              </span>
            ) : (
              "Delete"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
